import { HttpContextToken } from '@angular/common/http';

export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
export const SKIP_RETRY = new HttpContextToken<boolean>(() => false);
export const INJECT_ACCESS_TOKEN = new HttpContextToken<boolean>(() => false);
export const IS_MEASUREMENT_REQUEST = new HttpContextToken<boolean>(() => false);
export const MEASUREMENT_REQUEST_URL = new HttpContextToken(() => '');
